import { render, staticRenderFns } from "./LPDataTableFiltersModern.vue?vue&type=template&id=aa6d0f24&scoped=true&"
import script from "./LPDataTableFiltersModern.vue?vue&type=script&lang=js&"
export * from "./LPDataTableFiltersModern.vue?vue&type=script&lang=js&"
import style0 from "./LPDataTableFiltersModern.vue?vue&type=style&index=0&id=aa6d0f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d0f24",
  null
  
)

export default component.exports